import {Meta} from '@rdcomponents/meta/meta';
import {useState} from 'react';

import {appRoute} from '../../../../../app-route';
import {BreadCrumbs} from '../../../../../layout/bread-crumbs/bread-crumbs';
import {Page} from '../../../../../layout/page/page';
import {useLocale} from '../../../../../provider/locale/locale-hook';

import {ReviewAnalysisCompaniesTable} from './review-analysis-companies-table';
import {ReviewAnalysisCompanyGroupsTable} from './review-analysis-company-groups-table';

export function LocationsPage(): JSX.Element {
    const {reviewsAnalysisDashboard: dashboardRoute, reviewsAnalysisCompanies: companiesRoute} = appRoute;

    const {getLocalizedString} = useLocale();

    const [mode, setMode] = useState<'companies' | 'companyGroups'>('companies');

    return (
        <Page>
            <Meta title={getLocalizedString('CATEGORY_NAME__REVIEWS_ANALYSIS__COMPANIES')} />

            <BreadCrumbs
                list={[
                    {
                        path: dashboardRoute.path,
                        titleLangKey: 'CATEGORY_NAME__REVIEWS_ANALYSIS',
                    },
                    {
                        path: companiesRoute.path,
                        titleLangKey:
                            mode === 'companyGroups'
                                ? 'REVIEWS_ANALYSIS__BREADCRUMB__LOCATION_GROUPS'
                                : 'REVIEWS_ANALYSIS__BREADCRUMB__LOCATIONS',
                    },
                ]}
            />

            {mode === 'companies' && <ReviewAnalysisCompaniesTable mode={mode} setMode={setMode} />}
            {mode === 'companyGroups' && <ReviewAnalysisCompanyGroupsTable mode={mode} setMode={setMode} />}
        </Page>
    );
}
